export enum UpdateNodesAction {
  TAGS_REPLACE = 'tags-bulk-update',
  TAGS_ADD = 'tags-bulk-add',
  OPTIMIZATION_STATUS_UPDATE = 'optimize-status-bulk-update',
  NODE_ASSIGNEE_UPDATE = 'node-assignee-bulk-update',
  CNA_UPDATE = 'custom-node-attributes-bulk-update'
}

export const actionsToTriggerTreeReload: string[] = [
  UpdateNodesAction.OPTIMIZATION_STATUS_UPDATE,
  UpdateNodesAction.TAGS_ADD,
  UpdateNodesAction.TAGS_REPLACE
];

export const updateNodesDialogTitles = {
  [UpdateNodesAction.TAGS_ADD]: 'RUBIC_CUBE.TAGS_BULK_ADD',
  [UpdateNodesAction.TAGS_REPLACE]: 'RUBIC_CUBE.TAGS_BULK_REPLACE',
  [UpdateNodesAction.OPTIMIZATION_STATUS_UPDATE]: 'RUBIC_CUBE.OPTIMIZATION_STATUS_BULK_UPDATE',
  [UpdateNodesAction.NODE_ASSIGNEE_UPDATE]: 'RUBIC_CUBE.NODE_ASSIGNEE_BULK_UPDATE',
  [UpdateNodesAction.CNA_UPDATE]: 'RUBIC_CUBE.CNA_BULK_UPDATE'
};

export interface IUpdateNodesTagsDialogData {
  nodeIds: [];
  action: UpdateNodesAction;
  title: string;
  isDependency: boolean;
}
